module.exports = __webpack_public_path__ + "img/admin-dashboard.ec3ee5c0.png";